import { useEffect, useState } from "react";
import { useGetMetadocMetadataQuery } from "services/metadoc-api";
import { toEditableCodeValues } from "../../utils/codeMetadataUtils";

import type { EditableCodeValue } from "../../utils/codeMetadataUtils";

type UseCodeMetadataArgs = {
  metadocId: number;
  activeDocumentGroupId?: number;
  shouldFetch: boolean;
};

type UseCodeMetadataReturn = {
  codes: EditableCodeValue[];
  isLoading: boolean;
  isFetching: boolean;
};

/*
encapsulates code metadata fetching and transformation
converts api format to editable format for ui consumption
*/
export const useCodeMetadata = ({
  metadocId,
  activeDocumentGroupId,
  shouldFetch,
}: UseCodeMetadataArgs): UseCodeMetadataReturn => {
  const {
    data: codeMetadata,
    isFetching,
    isLoading,
  } = useGetMetadocMetadataQuery(
    { metadocId, type: "code" },
    { skip: !shouldFetch },
  );

  const [codes, setCodes] = useState<EditableCodeValue[]>([]);

  useEffect(() => {
    setCodes([]);
  }, [metadocId]);

  useEffect(() => {
    if (!codeMetadata || typeof activeDocumentGroupId !== "number") {
      setCodes([]);
      return;
    }

    const filteredCodeMetadata = codeMetadata.filter(
      (metadataRow) => metadataRow.document_group === activeDocumentGroupId,
    );
    const newCodeValues = toEditableCodeValues(filteredCodeMetadata);
    setCodes(newCodeValues);
  }, [activeDocumentGroupId, codeMetadata]);

  return {
    codes,
    isLoading,
    isFetching,
  };
};
